import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';

const SectionTwo = () => {
    const sectionTwoContent = [
        {   
            bgImage: './assests/images/eYantra-Frame76.svg', 
            sectionText: 'Branded Merchandise', 
            sectionParagraph: 'Strengthen your brand presence by offering personalized, high-quality merchandise that resonates with your audience and enhances your brand identity.', 
            sectionRedirect: '/branded-merchandise' 
        },
        {   
            bgImage: './assests/images/eYantra-Frame77.svg', 
            sectionText: 'Employee Recognition', 
            sectionParagraph: 'Foster a culture of appreciation with tailored employee recognition and reward programs designed to fit your organization’s values and needs.', 
            sectionRedirect: '/employee-recognition' 
        },
        {   
            bgImage: './assests/images/eYantra-Frame78.svg', 
            sectionText: 'Company Stores', 
            sectionParagraph: 'Turn your team into brand ambassadors with custom workwear that create a sense of pride and professionalism within your workforce.', 
            sectionRedirect: '/company-store' 
        },
    ];

    return (
        <>
            <Row>
                <h2 id="subHeading" className="mb-3">What we do</h2>
                {sectionTwoContent.map((item, index) => (
                    <Col md={4} key={index} className="mb-3">
                        <div
                            className="rounded h-100 d-flex flex-column justify-content-between"
                            style={{
                                backgroundImage: `url(${item.bgImage})`,
                                backgroundPosition: "top",
                                backgroundSize: "cover",
                                padding: '30px 20px 70px',
                                height: '100%',  // Ensure the div takes up the full height
                            }}
                        >
                            <div>
                                <h3 className="fs-24 fw-bold text-white">{item.sectionText}</h3>
                                
                                <p className="text-white fw-normal fs-14 w-md-80">
                                    {item.sectionParagraph}
                                </p>
                                 
                            </div>
                            <Button id="whiteBtn" className="align-self-start">
                                <Link to={item.sectionRedirect} className="text-decoration-none text-black">
                                    Know More
                                </Link>
                            </Button>
                        </div>
                    </Col>
                ))}
            </Row>
        </>
    );
};

export default SectionTwo;
